import React,{useState,useEffect,useRef} from 'react'

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AccountLayout from '../../../../../layout/components/AccountLayout';
import transactionReportServices from '../transactionReportServices';
import TransactionForm from '../components/TransactionForm';
import ProjectTransactionList from '../../project/components/ProjectTransactionList';
import VendorTransactionAnalytics from '../components/VendorTransactionAnalytics';
import PayeeTypeAnalytics from '../components/PayeeTypeAnalytics';
import CategoryTransactionAnalytics from '../components/CategoryTransactionAnalytics';


function TransactionItemListPage() {

    const [transactionItemList,steTransactionItemList] = useState(null);
    const getTransactionItemList = () =>{
        transactionReportServices.getItemList().then(res=>{
            steTransactionItemList(res.data); 
        }).catch(error=>{
            console.log(error);
        })
    }



    return (
        <AccountLayout>
            <div className='row'>
                <div className='col-md-6'><h4>Transaction Items List</h4></div>
                <div className='col-md-6'> 
                  <span className='float-end'><TransactionForm callBack={getTransactionItemList} /></span>
                </div>
            </div>  
            <ProjectTransactionList transactionItemList={transactionItemList} getTransactionItemList={getTransactionItemList} />
            
            <div className='row'>
              <div className='col-md-6'>
                <VendorTransactionAnalytics transactionItemList={transactionItemList} />
              </div>
              <div className='col-md-6'>
                <PayeeTypeAnalytics transactionItemList={transactionItemList} />
              </div>

              <div className='col-md-6'>
                <CategoryTransactionAnalytics transactionItemList={transactionItemList} />
              </div>
            </div>
            
        </AccountLayout>
    )
}

export default TransactionItemListPage